import { getThe, getTheBoolean, select } from 'src/store/selectors/utils'

const getTca = state => state.tca
const selectFromTca = select(getTca)

export const selectTcaSuccess = selectFromTca(getTheBoolean('success'))
export const selectTcaRequested = selectFromTca(getTheBoolean('requested'))
export const selectTcaError = selectFromTca(getThe('error'))
export const selectTcaLeadTimeHours = selectFromTca(getThe('leadTimeHours'))
